import { ServerConfig } from "@/config/config";
import { Axios } from "./auth-service";
import { AutoSaleRowSetting } from "@/models/auto-sale-row-setting";

class AutoSaleRowSettingsServiceClass {
	getUrl(dossierId:number, settingId?:number):string{
		let baseUrl = `${ServerConfig.mainAppHost}/dossier/${dossierId}/auto-sale-row-settings`;
		if (settingId != undefined) {
			return `${baseUrl}/${settingId}`;
		}
		return baseUrl;
	}

	async getAllSettings(dossierId:number):Promise<AutoSaleRowSetting[]>{
		let result = await Axios.get(this.getUrl(dossierId));
		return ((result.data || []) as any[]).map(d=>new AutoSaleRowSetting(d));
	}

	async getSetting(dossierId:number, settingId:number):Promise<AutoSaleRowSetting>{
		let result = await Axios.get(this.getUrl(dossierId, settingId));
		return new AutoSaleRowSetting(result.data);
	}

	async createSetting(dossierId:number, setting:AutoSaleRowSetting):Promise<AutoSaleRowSetting>{
		let result = await Axios.post(this.getUrl(dossierId), setting.getJSON());
		return new AutoSaleRowSetting(result.data);
	}

	async editSetting(dossierId:number, setting:AutoSaleRowSetting):Promise<AutoSaleRowSetting>{
		let result = await Axios.put(this.getUrl(dossierId, setting.ID), setting.getJSON());
		return new AutoSaleRowSetting(result.data);
	}

	async deleteSetting(dossierId:number, setting:AutoSaleRowSetting):Promise<void>{
		await Axios.delete(this.getUrl(dossierId, setting.ID));
	}
}

export const AutoSaleRowSettingsService = new AutoSaleRowSettingsServiceClass();